import {
    differenceBy,
    get,
    isEqual,
    sortBy
} from 'lodash';
import { createSelector } from 'reselect';
import { getEntityByName } from '../appEntities';
import {
    MERCHANTS_FAILURE,
    MERCHANTS_LOAD,
    MERCHANTS_SUCCESS
} from './merchantsActions';
import {
    generateMerchantIdsString,
    TOGGLE_SELECTOR_OPEN
} from '../MerchantSelector/merchantSelectorActions';

export function merchantsMapper(action) {
    let merchants = sortBy(get(action, 'merchants', []), ['name']);

    return merchants.reduce((acc, item) => {
        acc[item.merchantId] = item.name;

        return acc;
    }, {});
}

export default function reducer(state = {
    merchantMap: {},
    merchants: []
}, action = {}) {
    let newState;

    switch (action.type) {
        case MERCHANTS_LOAD:
            newState = {
                ...state,
                error: null,
                loaded: false,
                loading: true,
                merchants: []
            };

            return isEqual(state, newState) ? state : newState;

        case MERCHANTS_SUCCESS:
            newState = {
                ...state,
                loaded: true,
                loading: false,
                merchantMap: merchantsMapper(action),
                merchants: sortBy(action.merchants, ['name'])
            };

            return isEqual(state, newState) ? state : newState;

        case MERCHANTS_FAILURE:
            newState = {
                ...state,
                error: action.error,
                loaded: true,
                loading: false,
                merchants: []
            };

            return isEqual(state, newState) ? state : newState;

        case TOGGLE_SELECTOR_OPEN:
            newState = {
                ...state
            };
            if (action.isClosed && action.selectedMerchants) {
                newState.merchants = action.selectedMerchants.concat(differenceBy(state.merchants, action.selectedMerchants, (merchant) => merchant.merchantId));
            }

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getMerchantsEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'merchants')
);

export const getIsMerchantsLoaded = createSelector(
    getMerchantsEntity,
    (entity) => get(entity, 'loaded')
);

export const getIsMerchantsLoading = createSelector(
    getMerchantsEntity,
    (entity) => get(entity, 'loading')
);

export const getMerchants = createSelector(
    getMerchantsEntity,
    (entity) => get(entity, 'merchants')
);

export const getMerchantIdsString = createSelector(
    getMerchants,
    (merchantsArray = []) => {
        return generateMerchantIdsString(merchantsArray);
    }
);

export const getMerchantByMerchantId = createSelector(
    getMerchants,
    (state, merchantId) => (merchantId),
    (merchants, merchantId) => (
        merchants.find((merchant) => (merchant.merchantId === merchantId))
    )
);

export const getIsMerchantPaymentConfigured = createSelector(
    getMerchantByMerchantId,
    (merchant) => get(merchant, 'isPaymentConfigured')
);

export const getIsApmConfigured = createSelector(
    getMerchantByMerchantId,
    (merchant) => get(merchant, 'isApmConfigured')
);

export const getProcessorForMerchantId = createSelector(
    (state, merchantId) => getMerchantByMerchantId(state, merchantId),
    (merchant) => get(merchant, 'processor')
);

export const getProcessorTypeForMerchantId = createSelector(
    getProcessorForMerchantId,
    (processor) => (get(processor, 'processorType'))
);

export const getMerchantsError = createSelector(
    getMerchantsEntity,
    (entity) => get(entity, 'error')
);

export const getMerchantsErrorMessage = createSelector(
    getMerchantsError,
    (error) => get(error, 'message')
);

export const getMerchantsMapper = createSelector(
    getMerchantsEntity,
    (entity) => get(entity, 'merchantMap')
);
